import { useEffect, useState } from 'react';
import useViajesTraslado from '../../viajeTraslado/services/ViajeTrasladoService';
import { TransferReservationBaseFiltersFormType } from '../../viajeTraslado/components/ViajeTrasladoBaseFilters';
import {
  getDefaultFilters,
  getDefaultColumnVisibility,
  getDefaultSort,
  GestionDeleteColumnVisibility,
  loadDeleteStateFromLocalStorage,
  saveDeleteStateToLocalStorage
} from '../utils/gestionDeleteStorage';
import { useSuperQuery } from '@vadiun/react-hooks-legacy';

export { columnsLabels, getDefaultFilters  } from '../utils/gestionDeleteStorage';

export const useGestionDeleteReserves = () => {
  const viajesTrasladoService = useViajesTraslado();
  const [state, setState] = useState(loadDeleteStateFromLocalStorage);

  useEffect(() => {
    saveDeleteStateToLocalStorage(state);
  }, [state]);

  const getGestionDeleteReserves = useSuperQuery(
    () =>
      viajesTrasladoService.getAll(
        state.page,
        state.rowsPerPage,
        state.sort.sortBy,
        state.sort.sortDir,
        state.filters
      ),
    { showSpinner: true },
    [
      state.page,
      state.rowsPerPage,
      state.sort.sortBy,
      state.sort.sortDir,
      JSON.stringify(state.filters)
    ]
  );

  const onChangePage = (newPage: number) => {
    if (newPage !== state.page) {
      setState((prev) => ({ ...prev, page: newPage }));
    }
  };

  const onChangeRowsPerPage = (newRowsPerPage: number) => {
    setState((prev) => ({ ...prev, rowsPerPage: newRowsPerPage, page: 1 }));
  };

  const onSortChange = (direction: string | null, sortBy: string) => {
    setState((prev) => ({
      ...prev,
      sort: {
        sortDir: direction === 'desc' ? 'DESC' : 'ASC',
        sortBy
      },
      page: 1
    }));
  };

  const onFiltersChange = (
    filtersEntry: TransferReservationBaseFiltersFormType
  ) => {
    setState((prev) => ({ ...prev, filters: filtersEntry, page: 1 }));
  };

  const setColumnVisibility = (
    newColumnVisibility: GestionDeleteColumnVisibility
  ) => {
    setState((prev) => ({
      ...prev,
      columnVisibility: newColumnVisibility
    }));
  };

  const resetState = () => {
    setState({
      page: 1,
      rowsPerPage: 100,
      sort: getDefaultSort(),
      filters: getDefaultFilters(),
      columnVisibility: getDefaultColumnVisibility()
    });
  };



  return {
    gestionDeleteReserves: {
      data: getGestionDeleteReserves.data?.data || [],
      total: getGestionDeleteReserves.data?.total || 0,
      isLoading: getGestionDeleteReserves.isLoading,
      error: getGestionDeleteReserves.error,
      serverSideOptions: {
        page: state.page - 1,
        count: getGestionDeleteReserves.data?.total || 0,
        rowsPerPage: state.rowsPerPage,
        sortOrder: {
          name: state.sort.sortBy,
          direction: state.sort.sortDir.toLowerCase() as 'asc' | 'desc'
        }
      }
    },
    reload: getGestionDeleteReserves.reload,
    filters: state.filters,
    columnVisibility: state.columnVisibility,
    onFiltersChange,
    setColumnVisibility,
    resetState,
    onChangePage,
    onChangeRowsPerPage,
    onSortChange
  };
};


